// src/Components/common/HashRedirect.js
//
// Backward compatibility for the old hash URLs. Until the switch to path
// routing every link in the app, in emails, in bookmarks and in payment
// return URLs looked like https://careerclaw.com/#/jobs/saved. Those links
// still arrive; the "#/..." part never reaches the server, so the app shell
// loads at "/" and this component forwards the browser to the path form
// (/jobs/saved?x=y) with replace, so the old URL does not stay in history.
//
// Mounted once inside the Router. Renders nothing.

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const HashRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash || "";

    if (!hash.startsWith("#/")) return;

    // "#/login/?wl=acme" -> "/login/?wl=acme". Query strings that used to sit
    // inside the hash are kept as real query strings.
    const target = hash.slice(1);

    navigate(target, { replace: true });
  }, [navigate]);

  return null;
};

export default HashRedirect;
